import React from "react";
import { SvgIcon, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { MdTimer } from "react-icons/md";
import { DualActionModal } from "../../design";

export interface InactivityWarningModalProps {
  readonly open: boolean;
  readonly timeRemainingMinutes: number;
  readonly timeRemainingSeconds: number;
  readonly onStayActive: () => void;
  readonly onLogout: () => void;
  readonly modalProps?: Partial<React.ComponentProps<typeof DualActionModal>>;
}

/**
 * Modal component that displays inactivity warning with countdown timer.
 * Receives timer state as props to avoid circular dependency with context.
 */
export function InactivityWarningModal({
  open,
  timeRemainingMinutes,
  timeRemainingSeconds,
  onStayActive,
  onLogout,
  modalProps,
}: InactivityWarningModalProps) {
  
  const palette = useTheme().palette;
  return (
    <DualActionModal
      open={open}
      onClose={onStayActive}
      onConfirm={onStayActive}
      onReject={onLogout}
      injectContent={{
        maxWidth: "600px",
        icon: <SvgIcon component={MdTimer} fontSize="medium" />,
        header: "Inactivity Logout",
        body: (
          <Typography variant="body1" gutterBottom textAlign="center">
            You are about to be logged out due to inactivity. Are you still working or would you
            like to logout?
          </Typography>
        ),
        yesText: "Yes, I am still working",
        noText: "No, please log me out",
        onYesButtonClick: onStayActive,
        onNoButtonClick: onLogout,
        buttonStyles: {
          yesButton: { width: "fit-content" },
          noButton: {
            width: "fit-content",
            height: "100%",
            ":hover": {
              bgcolor: palette.error[4],
              color: "white",
            },
            bgcolor: palette.error[3],
            color: "white",
          },
        },
        ...modalProps?.injectContent,
      }}
      {...modalProps}
    />
  );
}
